import { render, staticRenderFns } from "./MergeCompany.vue?vue&type=template&id=71026a8f"
import script from "./MergeCompany.vue?vue&type=script&lang=js"
export * from "./MergeCompany.vue?vue&type=script&lang=js"
import style0 from "./MergeCompany.vue?vue&type=style&index=0&id=71026a8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports